import React, { Component } from 'react'
import { Button, Collapse } from 'react-bootstrap'

export interface TogglePanelProps {
  collapsibleId: string,
  header: React.ReactNode,
  children: React.ReactNode,
  isOpen: boolean,
  isDisabled: boolean,
  onHeaderClick: () => void
}

export default class TogglePanel extends Component<TogglePanelProps> {
  render() {
    const { collapsibleId, header, isOpen, isDisabled, onHeaderClick, children } = this.props

    return (
      <div className="pb-2">
        <Button size="sm" className="w-100" aria-controls={collapsibleId} aria-expanded={isOpen} onClick={onHeaderClick} disabled={isDisabled}>
            {header}
        </Button>
        <Collapse in={isOpen}>
          <div id={collapsibleId} className="m-2 p-2 section-border">
            {children}
          </div>
        </Collapse>
      </div>
    )
  }
}
